"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exit = exit;
const exit_1 = require("./errors/exit");
function exit(code = 0) {
    throw new exit_1.ExitError(code);
}
